var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgErrorTriangle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 15,
    viewBox: "0 0 16 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.6637 0.899003C8.4042 0.408503 7.5972 0.408503 7.3377 0.899003L0.587701 13.649C0.526939 13.7633 0.496816 13.8913 0.500266 14.0207C0.503717 14.1501 0.540624 14.2764 0.607391 14.3873C0.674159 14.4981 0.768509 14.5898 0.881249 14.6534C0.99399 14.717 1.12127 14.7503 1.2507 14.75H14.7507C14.88 14.7503 15.0072 14.717 15.1199 14.6535C15.2326 14.59 15.3268 14.4983 15.3935 14.3875C15.4602 14.2767 15.4971 14.1505 15.5005 14.0212C15.5039 13.8919 15.4737 13.7639 15.4129 13.6498L8.6637 0.899003ZM8.7507 12.5H7.2507V11H8.7507V12.5ZM7.2507 9.5V5.75H8.7507L8.75145 9.5H7.2507Z",
    fill: "#FE2626"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorTriangle);
export default __webpack_public_path__ + "static/media/error-triangle.f94d4eea6f8addb7a654ed396d1e6487.svg";
export { ForwardRef as ReactComponent };